/*!
 * jQuery Migrate - v3.3.0 - 2020-05-05T01:57Z
 * Copyright OpenJS Foundation and other contributors
 */
(function(factory) {
  "use strict";
  if (typeof define === "function" && define.amd) {
    define(["jquery"], function(jQuery2) {
      return factory(jQuery2, window);
    });
  } else if (typeof module === "object" && module.exports) {
    module.exports = factory(require("jquery"), window);
  } else {
    factory(jQuery, window);
  }
})(function(jQuery2, window2) {
  "use strict";
  jQuery2.migrateVersion = "3.3.0";
  function compareVersions(v1, v2) {
    var i, rVersionParts = /^(\d+)\.(\d+)\.(\d+)/, v1p = rVersionParts.exec(v1) || [], v2p = rVersionParts.exec(v2) || [];
    for (i = 1; i <= 3; i++) {
      if (+v1p[i] > +v2p[i]) {
        return 1;
      }
      if (+v1p[i] < +v2p[i]) {
        return -1;
      }
    }
    return 0;
  }
  function jQueryVersionSince(version) {
    return compareVersions(jQuery2.fn.jquery, version) >= 0;
  }
  (function() {
    if (!window2.console || !window2.console.log) {
      return;
    }
    if (!jQuery2 || !jQueryVersionSince("3.0.0")) {
      window2.console.log("JQMIGRATE: jQuery 3.0.0+ REQUIRED");
    }
    if (jQuery2.migrateWarnings) {
      window2.console.log("JQMIGRATE: Migrate plugin loaded multiple times");
    }
    window2.console.log("JQMIGRATE: Migrate is installed" + (jQuery2.migrateMute ? "" : " with logging active") + ", version " + jQuery2.migrateVersion);
  })();
  var warnedAbout = {};
  jQuery2.migrateDeduplicateWarnings = true;
  jQuery2.migrateWarnings = [];
  if (jQuery2.migrateTrace === void 0) {
    jQuery2.migrateTrace = true;
  }
  jQuery2.migrateReset = function() {
    warnedAbout = {};
    jQuery2.migrateWarnings.length = 0;
  };
  function migrateWarn(msg) {
    var console = window2.console;
    if (!jQuery2.migrateDeduplicateWarnings || !warnedAbout[msg]) {
      warnedAbout[msg] = true;
      jQuery2.migrateWarnings.push(msg);
      if (console && console.warn && !jQuery2.migrateMute) {
        console.warn("JQMIGRATE: " + msg);
        if (jQuery2.migrateTrace && console.trace) {
          console.trace();
        }
      }
    }
  }
  function migrateWarnProp(obj, prop, value, msg) {
    Object.defineProperty(obj, prop, {
      configurable: true,
      enumerable: true,
      get: function() {
        migrateWarn(msg);
        return value;
      },
      set: function(newValue) {
        migrateWarn(msg);
        value = newValue;
      }
    });
  }
  function migrateWarnFunc(obj, prop, newFunc, msg) {
    obj[prop] = function() {
      migrateWarn(msg);
      return newFunc.apply(this, arguments);
    };
  }
  if (window2.document.compatMode === "BackCompat") {
    migrateWarn("jQuery is not compatible with Quirks Mode");
  }
  var findProp, class2type = {}, oldInit = jQuery2.fn.init, oldFind = jQuery2.find, rattrHashTest = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/, rattrHashGlob = /\[(\s*[-\w]+\s*)([~|^$*]?=)\s*([-\w#]*?#[-\w#]*)\s*\]/g, rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
  jQuery2.fn.init = function(arg1) {
    var args = Array.prototype.slice.call(arguments);
    if (typeof arg1 === "string" && arg1 === "#") {
      migrateWarn("jQuery( '#' ) is not a valid selector");
      args[0] = [];
    }
    return oldInit.apply(this, args);
  };
  jQuery2.fn.init.prototype = jQuery2.fn;
  jQuery2.find = function(selector) {
    var args = Array.prototype.slice.call(arguments);
    if (typeof selector === "string" && rattrHashTest.test(selector)) {
      try {
        window2.document.querySelector(selector);
      } catch (err1) {
        selector = selector.replace(rattrHashGlob, function(_, attr, op, value) {
          return "[" + attr + op + '"' + value + '"]';
        });
        try {
          window2.document.querySelector(selector);
          migrateWarn("Attribute selector with '#' must be quoted: " + args[0]);
          args[0] = selector;
        } catch (err2) {
          migrateWarn("Attribute selector with '#' was not fixed: " + args[0]);
        }
      }
    }
    return oldFind.apply(this, args);
  };
  for (findProp in oldFind) {
    if (Object.prototype.hasOwnProperty.call(oldFind, findProp)) {
      jQuery2.find[findProp] = oldFind[findProp];
    }
  }
  migrateWarnFunc(
    jQuery2.fn,
    "size",
    function() {
      return this.length;
    },
    "jQuery.fn.size() is deprecated and removed; use the .length property"
  );
  migrateWarnFunc(
    jQuery2,
    "parseJSON",
    function() {
      return JSON.parse.apply(null, arguments);
    },
    "jQuery.parseJSON is deprecated; use JSON.parse"
  );
  migrateWarnFunc(
    jQuery2,
    "holdReady",
    jQuery2.holdReady,
    "jQuery.holdReady is deprecated"
  );
  migrateWarnFunc(
    jQuery2,
    "unique",
    jQuery2.uniqueSort,
    "jQuery.unique is deprecated; use jQuery.uniqueSort"
  );
  migrateWarnProp(
    jQuery2.expr,
    "filters",
    jQuery2.expr.pseudos,
    "jQuery.expr.filters is deprecated; use jQuery.expr.pseudos"
  );
  migrateWarnProp(
    jQuery2.expr,
    ":",
    jQuery2.expr.pseudos,
    "jQuery.expr[':'] is deprecated; use jQuery.expr.pseudos"
  );
  if (jQueryVersionSince("3.1.1")) {
    migrateWarnFunc(
      jQuery2,
      "trim",
      function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "");
      },
      "jQuery.trim is deprecated; use String.prototype.trim"
    );
  }
  if (jQueryVersionSince("3.2.0")) {
    migrateWarnFunc(
      jQuery2,
      "nodeName",
      function(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
      },
      "jQuery.nodeName is deprecated"
    );
  }
  if (jQueryVersionSince("3.3.0")) {
    migrateWarnFunc(
      jQuery2,
      "isNumeric",
      function(obj) {
        var type = typeof obj;
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, e.g. hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
      },
      "jQuery.isNumeric() is deprecated"
    );
    jQuery2.each(
      "Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),
      function(_, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
      }
    );
    migrateWarnFunc(
      jQuery2,
      "type",
      function(obj) {
        if (obj == null) {
          return obj + "";
        }
        return typeof obj === "object" || typeof obj === "function" ? class2type[Object.prototype.toString.call(obj)] || "object" : typeof obj;
      },
      "jQuery.type is deprecated"
    );
    migrateWarnFunc(
      jQuery2,
      "isFunction",
      function(obj) {
        return typeof obj === "function";
      },
      "jQuery.isFunction() is deprecated"
    );
    migrateWarnFunc(
      jQuery2,
      "isWindow",
      function(obj) {
        return obj != null && obj === obj.window;
      },
      "jQuery.isWindow() is deprecated"
    );
    migrateWarnFunc(
      jQuery2,
      "isArray",
      Array.isArray,
      "jQuery.isArray is deprecated; use Array.isArray"
    );
  }
  if (jQuery2.ajax) {
    var oldAjax = jQuery2.ajax;
    jQuery2.ajax = function() {
      var jQXHR = oldAjax.apply(this, arguments);
      if (jQXHR.promise) {
        migrateWarnFunc(
          jQXHR,
          "success",
          jQXHR.done,
          "jQXHR.success is deprecated and removed"
        );
        migrateWarnFunc(
          jQXHR,
          "error",
          jQXHR.fail,
          "jQXHR.error is deprecated and removed"
        );
        migrateWarnFunc(
          jQXHR,
          "complete",
          jQXHR.always,
          "jQXHR.complete is deprecated and removed"
        );
      }
      return jQXHR;
    };
  }
  var oldRemoveAttr = jQuery2.fn.removeAttr, oldToggleClass = jQuery2.fn.toggleClass, rmatchNonSpace = /\S+/g;
  jQuery2.fn.removeAttr = function(name) {
    var self = this;
    jQuery2.each(name.match(rmatchNonSpace), function(_i, attr) {
      if (jQuery2.expr.match.bool.test(attr)) {
        migrateWarn("jQuery.fn.removeAttr no longer sets boolean properties: " + attr);
        self.prop(attr, false);
      }
    });
    return oldRemoveAttr.apply(this, arguments);
  };
  jQuery2.fn.toggleClass = function(state) {
    if (state !== void 0 && typeof state !== "boolean") {
      return oldToggleClass.apply(this, arguments);
    }
    migrateWarn("jQuery.fn.toggleClass( boolean ) is deprecated");
    return this.each(function() {
      var className = this.getAttribute && this.getAttribute("class") || "";
      if (className) {
        jQuery2.data(this, "__className__", className);
      }
      if (this.setAttribute) {
        this.setAttribute(
          "class",
          className || state === false ? "" : jQuery2.data(this, "__className__") || ""
        );
      }
    });
  };
  function camelCase(string) {
    return string.replace(/-([a-z])/g, function(_, letter) {
      return letter.toUpperCase();
    });
  }
  var oldFnCss, internalSwapCall = false, ralphaStart = /^[a-z]/, rautoPx = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
  if (jQuery2.swap) {
    jQuery2.each(["height", "width", "reliableMarginRight"], function(_, name) {
      var oldHook = jQuery2.cssHooks[name] && jQuery2.cssHooks[name].get;
      if (oldHook) {
        jQuery2.cssHooks[name].get = function() {
          var ret;
          internalSwapCall = true;
          ret = oldHook.apply(this, arguments);
          internalSwapCall = false;
          return ret;
        };
      }
    });
  }
  jQuery2.swap = function(elem, options, callback, args) {
    var ret, name, old = {};
    if (!internalSwapCall) {
      migrateWarn("jQuery.swap() is undocumented and deprecated");
    }
    for (name in options) {
      old[name] = elem.style[name];
      elem.style[name] = options[name];
    }
    ret = callback.apply(elem, args || []);
    for (name in options) {
      elem.style[name] = old[name];
    }
    return ret;
  };
  if (jQueryVersionSince("3.4.0") && typeof Proxy !== "undefined") {
    jQuery2.cssProps = new Proxy(jQuery2.cssProps || {}, {
      set: function() {
        migrateWarn("JQMIGRATE: jQuery.cssProps is deprecated");
        return Reflect.set.apply(this, arguments);
      }
    });
  }
  if (!jQuery2.cssNumber) {
    jQuery2.cssNumber = {};
  }
  function isAutoPx(prop) {
    return ralphaStart.test(prop) && rautoPx.test(prop[0].toUpperCase() + prop.slice(1));
  }
  oldFnCss = jQuery2.fn.css;
  jQuery2.fn.css = function(name, value) {
    var origThis = this;
    if (typeof name !== "string") {
      jQuery2.each(name, function(n, v) {
        jQuery2.fn.css.call(origThis, n, v);
      });
    }
    if (typeof value === "number" && !isAutoPx(camelCase(name))) {
      migrateWarn("Use of number-typed values is deprecated in jQuery.fn.css");
    }
    return oldFnCss.apply(this, arguments);
  };
  var oldData = jQuery2.data;
  jQuery2.data = function(elem, name, value) {
    var curData, sameKeys, key;
    if (name && typeof name === "object" && arguments.length === 2) {
      curData = jQuery2.hasData(elem) && oldData.call(this, elem);
      sameKeys = {};
      for (key in name) {
        if (key !== camelCase(key)) {
          migrateWarn("jQuery.data() always sets/gets camelCased names: " + key);
          curData[key] = name[key];
        } else {
          sameKeys[key] = name[key];
        }
      }
      oldData.call(this, elem, sameKeys);
      return name;
    }
    if (name && typeof name === "string" && name !== camelCase(name)) {
      curData = jQuery2.hasData(elem) && oldData.call(this, elem);
      if (curData && name in curData) {
        migrateWarn("jQuery.data() always sets/gets camelCased names: " + name);
        if (arguments.length > 2) {
          curData[name] = value;
        }
        return curData[name];
      }
    }
    return oldData.apply(this, arguments);
  };
  if (jQuery2.fx) {
    var intervalValue, intervalMsg, oldTweenRun = jQuery2.Tween.prototype.run, linearEasing = function(pct) {
      return pct;
    };
    jQuery2.Tween.prototype.run = function() {
      if (jQuery2.easing[this.easing].length > 1) {
        migrateWarn(
          "'jQuery.easing." + this.easing.toString() + "' should use only one argument"
        );
        jQuery2.easing[this.easing] = linearEasing;
      }
      oldTweenRun.apply(this, arguments);
    };
    intervalValue = jQuery2.fx.interval || 13;
    intervalMsg = "jQuery.fx.interval is deprecated";
    if (window2.requestAnimationFrame) {
      Object.defineProperty(jQuery2.fx, "interval", {
        configurable: true,
        enumerable: true,
        get: function() {
          if (!window2.document.hidden) {
            migrateWarn(intervalMsg);
          }
          return intervalValue;
        },
        set: function(newValue) {
          migrateWarn(intervalMsg);
          intervalValue = newValue;
        }
      });
    }
  }
  var oldLoad = jQuery2.fn.load, oldEventAdd = jQuery2.event.add, originalFix = jQuery2.event.fix;
  jQuery2.event.props = [];
  jQuery2.event.fixHooks = {};
  migrateWarnProp(
    jQuery2.event.props,
    "concat",
    jQuery2.event.props.concat,
    "jQuery.event.props.concat() is deprecated and removed"
  );
  jQuery2.event.fix = function(originalEvent) {
    var event, type = originalEvent.type, fixHook = this.fixHooks[type], props = jQuery2.event.props;
    if (props.length) {
      migrateWarn("jQuery.event.props are deprecated and removed: " + props.join());
      while (props.length) {
        jQuery2.event.addProp(props.pop());
      }
    }
    if (fixHook && !fixHook._migrated_) {
      fixHook._migrated_ = true;
      migrateWarn("jQuery.event.fixHooks are deprecated and removed: " + type);
      if ((props = fixHook.props) && props.length) {
        while (props.length) {
          jQuery2.event.addProp(props.pop());
        }
      }
    }
    event = originalFix.call(this, originalEvent);
    return fixHook && fixHook.filter ? fixHook.filter(event, originalEvent) : event;
  };
  jQuery2.event.add = function(elem, types) {
    if (elem === window2 && types === "load" && window2.document.readyState === "complete") {
      migrateWarn("jQuery(window).on('load'...) called after load event occurred");
    }
    return oldEventAdd.apply(this, arguments);
  };
  jQuery2.each(["load", "unload", "error"], function(_, name) {
    jQuery2.fn[name] = function() {
      var args = Array.prototype.slice.call(arguments, 0);
      if (name === "load" && typeof args[0] === "string") {
        return oldLoad.apply(this, args);
      }
      migrateWarn("jQuery.fn." + name + "() is deprecated");
      args.splice(0, 0, name);
      if (arguments.length) {
        return this.on.apply(this, args);
      }
      this.triggerHandler.apply(this, args);
      return this;
    };
  });
  jQuery2.each(
    "blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),
    function(_i, name) {
      jQuery2.fn[name] = function(data, fn) {
        migrateWarn("jQuery.fn." + name + "() event shorthand is deprecated");
        return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
      };
    }
  );
  jQuery2(function() {
    jQuery2(window2.document).triggerHandler("ready");
  });
  jQuery2.event.special.ready = {
    setup: function() {
      if (this === window2.document) {
        migrateWarn("'ready' event is deprecated");
      }
    }
  };
  jQuery2.fn.extend({
    bind: function(types, data, fn) {
      migrateWarn("jQuery.fn.bind() is deprecated");
      return this.on(types, null, data, fn);
    },
    unbind: function(types, fn) {
      migrateWarn("jQuery.fn.unbind() is deprecated");
      return this.off(types, null, fn);
    },
    delegate: function(selector, types, data, fn) {
      migrateWarn("jQuery.fn.delegate() is deprecated");
      return this.on(types, selector, data, fn);
    },
    undelegate: function(selector, types, fn) {
      migrateWarn("jQuery.fn.undelegate() is deprecated");
      return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
    },
    hover: function(fnOver, fnOut) {
      migrateWarn("jQuery.fn.hover() is deprecated");
      return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
    }
  });
  var rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi, origHtmlPrefilter = jQuery2.htmlPrefilter, makeMarkup = function(html) {
    var doc = window2.document.implementation.createHTMLDocument("");
    doc.body.innerHTML = html;
    return doc.body && doc.body.innerHTML;
  }, warnIfChanged = function(html) {
    var changed = html.replace(rxhtmlTag, "<$1></$2>");
    if (changed !== html && makeMarkup(html) !== makeMarkup(changed)) {
      migrateWarn("HTML tags must be properly nested and closed: " + html);
    }
  };
  jQuery2.UNSAFE_restoreLegacyHtmlPrefilter = function() {
    jQuery2.htmlPrefilter = function(html) {
      warnIfChanged(html);
      return html.replace(rxhtmlTag, "<$1></$2>");
    };
  };
  jQuery2.htmlPrefilter = function(html) {
    warnIfChanged(html);
    return origHtmlPrefilter(html);
  };
  var oldOffset = jQuery2.fn.offset;
  jQuery2.fn.offset = function() {
    var docElem, elem = this[0], bogus = { top: 0, left: 0 };
    if (!elem || !elem.nodeType) {
      migrateWarn("jQuery.fn.offset() requires a valid DOM element");
      return void 0;
    }
    docElem = (elem.ownerDocument || window2.document).documentElement;
    if (!jQuery2.contains(docElem, elem)) {
      migrateWarn("jQuery.fn.offset() requires an element connected to a document");
      return bogus;
    }
    return oldOffset.apply(this, arguments);
  };
  if (jQuery2.ajax) {
    var oldParam = jQuery2.param;
    jQuery2.param = function(data, traditional) {
      var ajaxTraditional = jQuery2.ajaxSettings && jQuery2.ajaxSettings.traditional;
      if (traditional === void 0 && ajaxTraditional) {
        migrateWarn("jQuery.param() no longer uses jQuery.ajaxSettings.traditional");
        traditional = ajaxTraditional;
      }
      return oldParam.call(this, data, traditional);
    };
  }
  var oldSelf = jQuery2.fn.andSelf || jQuery2.fn.addBack;
  jQuery2.fn.andSelf = function() {
    migrateWarn("jQuery.fn.andSelf() is deprecated and removed, use jQuery.fn.addBack()");
    return oldSelf.apply(this, arguments);
  };
  if (jQuery2.Deferred) {
    var oldDeferred = jQuery2.Deferred, tuples = [
      // Action, add listener, callbacks, .then handlers, final state
      [
        "resolve",
        "done",
        jQuery2.Callbacks("once memory"),
        jQuery2.Callbacks("once memory"),
        "resolved"
      ],
      [
        "reject",
        "fail",
        jQuery2.Callbacks("once memory"),
        jQuery2.Callbacks("once memory"),
        "rejected"
      ],
      [
        "notify",
        "progress",
        jQuery2.Callbacks("memory"),
        jQuery2.Callbacks("memory")
      ]
    ];
    jQuery2.Deferred = function(func) {
      var deferred = oldDeferred(), promise = deferred.promise();
      deferred.pipe = promise.pipe = function() {
        var fns = arguments;
        migrateWarn("deferred.pipe() is deprecated");
        return jQuery2.Deferred(function(newDefer) {
          jQuery2.each(tuples, function(i, tuple) {
            var fn = typeof fns[i] === "function" && fns[i];
            deferred[tuple[1]](function() {
              var returned = fn && fn.apply(this, arguments);
              if (returned && typeof returned.promise === "function") {
                returned.promise().done(newDefer.resolve).fail(newDefer.reject).progress(newDefer.notify);
              } else {
                newDefer[tuple[0] + "With"](
                  this === promise ? newDefer.promise() : this,
                  fn ? [returned] : arguments
                );
              }
            });
          });
          fns = null;
        }).promise();
      };
      if (func) {
        func.call(deferred, deferred);
      }
      return deferred;
    };
    jQuery2.Deferred.exceptionHook = oldDeferred.exceptionHook;
  }
  return jQuery2;
});
